export enum SupportedTypeCodes {
  BoelsCMSFlexComponent = 'BoelsCMSFlexComponent',
  CMSFlexComponent = 'CMSFlexComponent',
}
